import Fetch, { V1 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';

const DEFAULT_GET_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

const getPrimeTrial = () => {
  const resourceUrl = `${V1}stock-prime/trial/status/`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message);
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export { getPrimeTrial };
